import { EXPRESS_API } from 'configs/api/expressApi';
import { IQuickVideo, IUpsertQuickVideoBody } from './types';
import { useMutation, useQueryClient } from 'react-query';
import { quickVideoKeys } from './quickVideoKeys';
import { useToastError } from 'lib/hooks';
import { successToast } from 'lib/components/toasts/success';
import { useTranslation } from 'react-i18next';

const createQuickVideo = async (body: IUpsertQuickVideoBody) => {
  return (await EXPRESS_API.post('quick-videos', body)).data as IQuickVideo;
};

export const useCreateQuickVideoMutation = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  const { t } = useTranslation();
  return useMutation(createQuickVideo, {
    onError: error => {
      showError(error);
    },
    onSuccess: () => {
      // close modal, invalidate queries
      successToast({ title: t('Quick Video successfully created.') });
      queryClient.invalidateQueries(quickVideoKeys.all());
      if (onSuccess) {
        onSuccess();
      }
    },
  });
};
